import { gql } from '@grandvisionhq/graphql';
import AppointmentFragment from '../fragments/appointment.js';

const appointmentsFragment = gql`
  fragment AppointmentsFragment on Appointment {
    ...AppointmentFragment
  }
  ${AppointmentFragment}
`;
var GET_MY_APPOINTMENTS = gql`
  query getMyAppointments {
    me {
      id
      appointments {
        ...AppointmentsFragment
      }
    }
  }
  ${appointmentsFragment}
`;

export { GET_MY_APPOINTMENTS as default };
//# sourceMappingURL=get-my-appointments.js.map
